// import React from "react";
import "./Ac.css";
import { useNavigate } from "react-router-dom";

import React, { useState, useEffect } from "react";

import BrochurePopup from "../components/BrochurePopup";
import acBrochure from "../components/images/AC BROCHURE.pdf";

import TvBrochurePopup from "./BrochurePopup";
import sImage1 from "../components/images/ACB1.jpg";
import sImage2 from "../components/images/ACB2.png";
import sImage3 from "../components/images/ACB3.jpg";
import sImage4 from "../components/images/ac m1.jpg";
import sImage5 from "../components/images/ac m2.jpg";
import sImage6 from "../components/images/ac m3.jpg";
import Slider from "react-slick";
// import tvBrochure from "../components/images/TV BROCHURE 2026.pdf";


const bannerImages = [sImage1, sImage2, sImage3];
const AC = () => {

  const settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false,
    pauseOnHover: false
  };

const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const alreadyShown = localStorage.getItem("tvBrochureShown");

    if (!alreadyShown) {
      const timer = setTimeout(() => {
        setOpen(true);
        localStorage.setItem("tvBrochureShown", "true");
      }, 800);

      return () => clearTimeout(timer);
    }
  }, []);


  return (
    <div className="ac-page">

 <BrochurePopup
        brochure={acBrochure}
        title="AC Brochure 2026"
        subtitle="Discover Redwolf Air Conditioners with fast cooling, energy efficiency and long-lasting performance."
        fileName="Redwolf-AC-Brochure-2026.pdf"
        icon="❄️"
      />

     <div className="tcops-slider">
        <Slider {...settings}>
          {bannerImages.map((image, index) => (
            <div key={index}>
              <img src={image} alt={`Banner ${index + 1}`} className="slider-image" />
            </div>
          ))}
        </Slider>
      </div>


      {/* ========== HERO SECTION ========== */}
      {/* <section className="ac-hero">
        <div className="ac-hero-overlay">
          <h1>
            <span className="brand-red">Red</span>
            <span className="brand-green">wolf</span> Smart Air Conditioners
          </h1>

          <p>
            Experience next-generation cooling with intelligent,
            energy-efficient and eco-friendly air conditioning technology.
          </p>

          <button className="primary-btn">Explore Models</button>
        </div>
      </section> */}

      {/* ========== BANNER STRIP ========== */}
      <section className="ac-banner-strip">
        <div className="banner-item">⚡ Fast Cooling</div>
        <div className="banner-item">🌱 Energy Efficient</div>
        <div className="banner-item">🔇 Silent Operation</div>
        <div className="banner-item">📱 Smart Control</div>
      </section>

      {/* ========== ABOUT SECTION ========== */}

      <section className="ac-about">
  <h2 className="section-heading fade-up">
    Smart Cooling, Powered by <span className="red">Red </span>
    <span className="green">Wolf</span>
  </h2>

  <div className="about-content">
    <p className="fade-left">
      We stand behind the quality and reliability of every Red Wolf product. 
      Our warranty policy ensures peace of mind with comprehensive coverage 
      against manufacturing defects, reinforcing our commitment to long-term 
      performance and customer satisfaction.
    </p>

    <p className="fade-right">
      We ensure efficient and secure delivery of all our products through a 
      streamlined logistics network. Our focus is on timely dispatch, careful 
      handling, and reliable doorstep delivery to provide a smooth and 
      hassle-free experience.
    </p>

    <p className="fade-up delay">
      At Red Wolf, we prioritize prompt and dependable after-sales support. 
      Our dedicated service network is committed to delivering timely 
      assistance, professional maintenance, and seamless issue resolution 
      to ensure uninterrupted comfort for our customers.
    </p>
  </div>
</section>

{/* <section className="ac-about">
  <h2 className="section-heading fade-up">
    Why Choose <span className="red">Red </span>
    <span className="green">Wolf</span> Air Conditioners?
  </h2>

  <div className="about-content">
    <p className="fade-left">
      Red Wolf Air Conditioners are engineered for modern homes and commercial
      spaces, delivering powerful cooling with advanced inverter technology.
      Each model is built to provide fast temperature control, stable
      performance, and long-lasting durability.
    </p>

    <p className="fade-right">
      Designed to handle extreme heat and high humidity, Red Wolf ACs
      intelligently adapt to changing weather conditions. Optimized airflow
      and silent operation ensure consistent comfort with reduced energy
      consumption.
    </p>

    <p className="fade-up delay">
      With smart controls, premium build quality, and energy-efficient
      performance, Red Wolf ACs offer a perfect balance of comfort, savings,
      and modern design for every space.
    </p>
  </div>
</section> */}



      {/* ========== FEATURES ========== */}
      <section className="ac-features">
        <h2 className="section-heading">
          Advanced <span className="red">Fea</span>
          <span className="green">tures</span>
        </h2>

        <div className="feature-grid">
          <div className="feature-card">
            <h3>Turbo Cooling</h3>
            <p>
              Rapid temperature drop even in extreme 50°C outdoor conditions.
            </p>
          </div>

          <div className="feature-card">
            <h3>Inverter Technology</h3>
            <p>
              Smart compressor speed control for energy efficiency and stability.
            </p>
          </div>

          <div className="feature-card">
            <h3>Silent Mode</h3>
            <p>
              Ultra-low noise operation ensures peaceful sleep and comfort.
            </p>
          </div>

          <div className="feature-card">
            <h3>Smart Diagnostics</h3>
            <p>
              Built-in self-check system improves reliability and service life.
            </p>
          </div>
        </div>
      </section>

      {/* ========== MODELS ========== */}
  
{/* <section className="ac-models">
  <h2 className="section-heading">
    Our <span className="red">Air Conditioner</span>{" "}
    <span className="green">Models</span>
  </h2>

  <div className="model-grid">
   
    <div
  className="model-card"
  onClick={() => navigate("/contact")}
  style={{ cursor: "pointer" }}
>
  <div className="model-img">
    <img src={sImage4} alt="Red Wolf 1 Ton 3 Star AC" />
  </div>

  <h3>Red Wolf 1 Ton 3★ Split Inverter AC</h3>
  <p>
  Ideal for small rooms up to 120 sq. ft., this AC delivers power-saving cooling
  designed for compact spaces, making it a perfect choice for bedrooms and
  small offices.
</p>

</div>


  
    <div className="model-card"
    
  onClick={() => navigate("/contact")}
  style={{ cursor: "pointer" }}>
    
      <div className="model-img">
        <img src={sImage5} alt="Red Wolf 1.5 Ton 3 Star AC" />
      </div>
      <h3>Red Wolf 1.5 Ton 3★ Split Inverter AC</h3>

      <p>
  Best suited for medium-sized rooms (120–180 sq. ft.), this AC delivers
  balanced cooling with excellent energy efficiency, making it an ideal
  choice for living rooms and master bedrooms.
</p>

    </div>

   
    <div className="model-card"
    
  onClick={() => navigate("/contact")}
  style={{ cursor: "pointer" }}>
      <div className="model-img">
        <img src={sImage6} alt="Red Wolf 2 Ton 3 Star AC" />
      </div>
      <h3>Red Wolf 2 Ton 3★ Split Inverter AC</h3>
      <p>
  Built for large rooms (180+ sq. ft.), this AC delivers heavy-duty cooling
  with fast and powerful performance, making it an ideal choice for halls
  and large living areas.
</p>

     
    </div>
  </div>
</section> */}




<section className="ac-models">
  <h2 className="section-heading">
    Explore Our <span className="red">AC</span>{" "}
    <span className="green">Range</span>
  </h2>

  <div className="model-grid">

    {/* MODEL 1 */}
    <div
      className="model-card"
      onClick={() => navigate("/contact")}
      style={{ cursor: "pointer" }}
    >
      <div className="model-img">
        <img src={sImage4} alt="Red Wolf 1 Ton 5 Star AC" />
      </div>

      <h3>Red Wolf 1 Ton 5★ Split Inverter AC</h3>
      <p>
        Ideal for small rooms up to 120 sq. ft., this AC delivers efficient
        cooling with low power consumption—perfect for bedrooms and compact
        office spaces.
      </p>
    </div>

    {/* MODEL 2 */}
    <div
      className="model-card"
      onClick={() => navigate("/contact")}
      style={{ cursor: "pointer" }}
    >
      <div className="model-img">
        <img src={sImage5} alt="Red Wolf 1.5 Ton 5 Star AC" />
      </div>

      <h3>Red Wolf 1.5 Ton 5★ Split Inverter AC</h3>
      <p>
        Designed for medium-sized rooms (120–180 sq. ft.), it offers balanced
        cooling performance, energy efficiency, and consistent comfort for
        living rooms and master bedrooms.
      </p>
    </div>

    {/* MODEL 3 */}
    <div
      className="model-card"
      onClick={() => navigate("/contact")}
      style={{ cursor: "pointer" }}
    >
      <div className="model-img">
        <img src={sImage6} alt="Red Wolf 2 Ton 5 Star AC" />
      </div>

      <h3>Red Wolf 2 Ton 5★ Split Inverter AC</h3>
      <p>
        Built for large rooms above 180 sq. ft., this powerful AC provides fast,
        heavy-duty cooling, making it ideal for halls and spacious living areas.
      </p>
    </div>

  </div>
</section>




      {/* ========== USAGE ========== */}
  {/* <section className="ac-usage">
  <h2 className="section-heading">
    Designed for <span className="red">Perfect Cooling</span> in Every{" "}
    <span className="green">Environment</span>
  </h2>

  <p className="usage-subtext">
    Red Wolf Air Conditioners are built to deliver reliable, energy-efficient
    cooling across different spaces, ensuring comfort, performance, and
    durability wherever they are installed.
  </p>

  <div className="usage-grid">
    <div className="usage-card">
      <div className="usage-icon">🏠</div>
      <h3>Residential Homes</h3>
      <p>
        Enjoy quiet, consistent cooling for bedrooms and living areas.
        Designed to maintain ideal comfort levels all day and night
        while saving energy.
      </p>
    </div>

    <div className="usage-card">
      <div className="usage-icon">🏢</div>
      <h3>Corporate Offices</h3>
      <p>
        Maintain a productive work environment with stable temperature
        control and low power consumption, even during extended
        working hours.
      </p>
    </div>

    <div className="usage-card">
      <div className="usage-icon">🏬</div>
      <h3>Retail & Showrooms</h3>
      <p>
        Create a pleasant shopping experience with reliable cooling
        that performs efficiently during peak customer traffic.
      </p>
    </div>

    <div className="usage-card">
      <div className="usage-icon">🏭</div>
      <h3>Commercial Spaces</h3>
      <p>
        Heavy-duty cooling solutions engineered for large areas,
        delivering continuous performance with durability and
        energy efficiency.
      </p>
    </div>
  </div>
</section> */}
<section className="ac-usage">
  <h2 className="section-heading">
    Perfect Cooling for <span className="red">Every</span>{" "}
    <span className="green">Space</span>
  </h2>

  <p className="usage-subtext">
    Red Wolf Air Conditioners are engineered to deliver reliable,
    energy-efficient cooling across a wide range of spaces—ensuring
    comfort, performance, and durability wherever they’re installed.
  </p>

  <div className="usage-grid">
    <div className="usage-card">
      <div className="usage-icon">🏠</div>
      <h3>Residential Homes</h3>
      <p>
        Enjoy quiet, consistent cooling for bedrooms and living areas.
        Designed to maintain ideal comfort levels day and night while
        optimizing energy savings.
      </p>
    </div>

    <div className="usage-card">
      <div className="usage-icon">🏢</div>
      <h3>Corporate Offices</h3>
      <p>
        Create a productive work environment with stable temperature
        control and low power consumption—even during extended
        working hours.
      </p>
    </div>

    <div className="usage-card">
      <div className="usage-icon">🏬</div>
      <h3>Retail & Showrooms</h3>
      <p>
        Enhance the shopping experience with reliable cooling that
        performs efficiently during peak customer traffic.
      </p>
    </div>

    <div className="usage-card">
      <div className="usage-icon">🏭</div>
      <h3>Commercial Spaces</h3>
      <p>
        Heavy-duty cooling solutions engineered for large areas,
        delivering continuous performance with long-lasting durability
        and energy efficiency.
      </p>
    </div>
  </div>
</section>



      {/* ========== BENEFITS ========== */}
   {/* <section className="ac-benefits">
  <h2 className="section-heading">
    Why Customers <span className="red">Love</span>{" "}
    <span className="green">Red Wolf</span>
  </h2>

  <p className="benefit-subtext">
    Red Wolf Air Conditioners are designed to deliver comfort, savings,
    and reliability. Every feature is built to enhance your everyday
    cooling experience while keeping long-term costs low.
  </p>

  <div className="benefit-grid">
    <div className="benefit-card">
      <span className="benefit-icon">💡</span>
      <h4>Lower Energy Bills</h4>
      <p>
        Advanced inverter technology optimizes power usage,
        significantly reducing electricity consumption without
        compromising cooling performance.
      </p>
    </div>

    <div className="benefit-card">
      <span className="benefit-icon">🛠️</span>
      <h4>Minimal Maintenance</h4>
      <p>
        High-quality components and smart system monitoring
        minimize breakdowns and reduce maintenance costs over time.
      </p>
    </div>

    <div className="benefit-card">
      <span className="benefit-icon">🌱</span>
      <h4>Environment Friendly</h4>
      <p>
        Uses eco-safe refrigerants that lower environmental impact
        while delivering efficient and responsible cooling.
      </p>
    </div>

    <div className="benefit-card">
      <span className="benefit-icon">⏳</span>
      <h4>Extended Lifespan</h4>
      <p>
        Built-in protection systems ensure durability and consistent
        performance, even during long hours of continuous operation.
      </p>
    </div>
  </div>
</section> */}
<section className="ac-benefits">
  <h2 className="section-heading">
    What Makes <span className="red">Red Wolf</span>{" "}
    <span className="green">Different?</span>
  </h2>

  <p className="benefit-subtext">
    Red Wolf Air Conditioners are designed to deliver superior comfort,
    long-term savings, and dependable performance. Every feature is
    engineered to enhance your everyday cooling experience while
    keeping ownership costs low.
  </p>

  <div className="benefit-grid">
    <div className="benefit-card">
      <span className="benefit-icon">💡</span>
      <h4>Lower Energy Bills</h4>
      <p>
        Advanced inverter technology optimizes power usage,
        significantly reducing electricity consumption without
        compromising cooling performance.
      </p>
    </div>

    <div className="benefit-card">
      <span className="benefit-icon">🛠️</span>
      <h4>Minimal Maintenance</h4>
      <p>
        High-quality components and smart system design reduce
        breakdowns and lower maintenance costs over time.
      </p>
    </div>

    <div className="benefit-card">
      <span className="benefit-icon">🌱</span>
      <h4>Environment Friendly</h4>
      <p>
        Uses eco-safe refrigerants to minimize environmental impact
        while delivering efficient and responsible cooling.
      </p>
    </div>

    <div className="benefit-card">
      <span className="benefit-icon">⏳</span>
      <h4>Extended Lifespan</h4>
      <p>
        Built-in protection systems ensure durability and consistent
        performance, even during long hours of continuous operation.
      </p>
    </div>
  </div>
</section>


  

{/* ========== FAQ ========== */}
{/* <section className="ac-faq">
  <h2 className="section-heading">
    Frequently Asked <span className="red">Questions</span>
  </h2>

  <div className="faq-grid">
    <div className="faq-item">
      <h4>Is Red Wolf AC energy efficient?</h4>
      <p>
        Yes, all Red Wolf AC models use advanced inverter technology that optimizes
        power consumption while delivering powerful cooling.
      </p>
    </div>

    <div className="faq-item">
      <h4>Do Red Wolf ACs support smart control?</h4>
      <p>
        Selected models come with smart control features, allowing you to manage
        temperature and modes using remote or mobile app.
      </p>
    </div>

    <div className="faq-item">
      <h4>Is installation service available?</h4>
      <p>
        Yes, professional installation is available through authorized service
        partners to ensure safe and proper setup.
      </p>
    </div>
  </div>
</section> */}

<section className="ac-faq">
  <h2 className="section-heading">
    Frequently Asked <span className="red">Questions</span>
  </h2>

  <div className="faq-grid">
    <div className="faq-item">
      <h4>Does using a Red Wolf AC lower electricity consumption?</h4>
      <p>
        Yes. All Red Wolf ACs are built to deliver powerful cooling while 
        minimizing power usage, making them a cost-effective choice 
        for daily use.
      </p>
    </div>

    <div className="faq-item">
      <h4>Do Red Wolf ACs support smart control?</h4>
      <p>
        Selected models come equipped with smart control features, 
        allowing you to manage temperature and modes conveniently 
        via remote.
      </p>
    </div>

    <div className="faq-item">
      <h4>Is installation service available?</h4>
      <p>
        Yes. Professional installation is available through authorized 
        service partners to ensure safe, proper, and hassle-free setup.
      </p>
    </div>
  </div>
</section>


 {/* <section className="brochure-section popup">
      <div className="brochure-box">
        <button
          className="close-btn"
          onClick={() => setOpen(false)}
        >
          ✕
        </button>

        <h2>
          Download <span>TV Brochure 2026</span>
        </h2>

        <p>
          Explore complete specifications, features, and smart technology
          details of <strong>Red Wolf TVs</strong> in our official brochure.
        </p>

        <a
          href={tvBrochure}
          download
          className="brochure-btn"
        >
          📄 Download TV Brochure (PDF)
        </a>
      </div>
    </section>  */}
     {/* <TvBrochurePopup /> */}


{/* <section className="ac-brochure-section">
  <div className="ac-brochure-card">
    <div className="ac-brochure-content">
      <h2>
        Download <span>AC Brochure</span>
      </h2>

      <p>
        Explore our latest Air Conditioner range with complete details
        including cooling capacity, inverter technology, energy ratings,
        features, and warranty information.
      </p>

      <a
        href={acBrochure}
        download
        className="brochure-btn ac-btn"
      >
        ❄️ Download AC Brochure
      </a>
    </div>
  </div>
</section> */}

<section className="ac-brochure-section">
  <div className="ac-brochure-card">
    <div className="ac-brochure-content">
      <h2>
        The Ultimate Guide to <span>Smart Cooling </span>
      </h2>

      <p>
        Discover advanced technology, superior performance, energy savings,
        and our commitment to warranty assurance and dependable service.
      </p>

      <a
        href={acBrochure}
        download
        className="brochure-btn ac-btn"
      >
        ❄️ Download AC Brochure
      </a>
    </div>
  </div>
</section>




    </div>
  );
};

export default AC;
